<template>
  <div class="page-404">
    <router-link to="/" class="button return-button">
      <img src="../assets/pictos/back-arrow.svg">
      Revenir<br>
      à l’accueil
    </router-link>
    <div class="head">
      <img src="../assets/pictos/404-illu.svg" alt="image 404">
    </div>
    <div class="content">
      <img src="../assets/pictos/404-picto.svg" alt="image 404">
      <p>
        Cette page n’existe pas ou plus !
        <br>
        Vous trouverez certainement cette information sur notre <router-link to="/" class="link">page d’accueil</router-link>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style lang="scss">
.page-404 {
  position: relative;
  margin-top: $v-spacer-xl;
  .head {
    background-color: #fff;
    border-radius: $radius $radius 0 0;
    height: 130px;
    position: relative;
    img {
      position: absolute;
      bottom: -33px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content {
    background-color: $primary-color;
    color: #fff;
    border-radius: 0 0 $radius $radius;
    padding: 120px 0 50px 0;
    .link {
      color: #fff;
    }
    p {
      margin-top: 60px;
    }
  }
}
</style>
